module.exports = "/fonts/fa-brands-400.svg?38975343b586296e9b73e6b56cc3ec5d";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-brands-400.svg
// module id = YMlO
// module chunks = 0 1